export default __webpack_public_path__ + "static/media/Refazer.11c56acb.svg";